export default __webpack_public_path__ + "static/media/Knob_DHK301.19b9edaa.obj";